import PropTypes from 'prop-types'
import { DialogContent } from '@mui/material'
// import FormikSelect from '../../../molecules/FormikSelect'
import NotesPreview from './NotesPreview'

const NotePreview = ({ content }) => {
  return (
    <>
      <DialogContent dividers={true}>
        <NotesPreview comment={content} />
      </DialogContent>
    </>
  )
}

NotePreview.propTypes = {
  content: PropTypes.string,
}

export default NotePreview
